import { Mail, Users, Zap, Inbox } from "lucide-react";

export const FeaturesSection = () => {
  return (
    <section id="features" className="py-20 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center mb-8">
          <img 
            src="/maia-envelope.svg" 
            alt="Maia Envelope" 
            className="w-[200px] h-auto mb-6 animate-float"
          />
          <h2 className="text-3xl font-bold text-center mb-4">Unlock the Full Potential of Maia</h2>
          <p className="text-lg text-white/80 text-center mb-16 max-w-3xl mx-auto">
            Stop losing time with daily emailing activities and focus on what is important, connection with your customers
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <Mail className="w-6 h-6 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2 text-left">AI-Powered Email Management</h3>
                <ul className="space-y-2 text-white/80 text-left">
                  <li>Transform your inbox with intelligent response generation</li>
                  <li>Cut email response time by up to 90%</li>
                  <li>Context-aware replies that maintain your tone</li>
                </ul>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <Inbox className="w-6 h-6 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2 text-left">Multi-Account Intelligence</h3>
                <ul className="space-y-2 text-white/80 text-left">
                  <li>Seamlessly change in between multiple accounts</li>
                  <li>Add as many Gmail accounts as you need</li>
                  <li>Secure Gmail integration with OAuth</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <Users className="w-6 h-6 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2 text-left">Custom AI Assistants</h3>
                <ul className="space-y-2 text-white/80 text-left">
                  <li>Create specialized AI assistants with ease</li>
                  <li>Train assistants with company documents</li>
                  <li>Maintain brand voice across communications</li>
                </ul>
              </div>
            </div>
            <div className="flex items-start space-x-4">
              <Zap className="w-6 h-6 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2 text-left">Batch Email Processing</h3>
                <ul className="space-y-2 text-white/80 text-left">
                  <li>Process multiple emails simultaneously</li>
                  <li>Maintain consistency across bulk responses</li>
                  <li>Smart-regeneration feature with comments</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};